import React from 'react'
import Header from 'components/headers/wallet'
import ErrorIcon from 'assets/images/error/errorbug.svg'
import { useNavigate } from 'react-router-dom'
export default function ErrorBug() {
    const navigate = useNavigate()
    return (
        <div className=" h-screen flex flex-col">
            <div className=" grow-0">
                <Header title="خطا" />
            </div>
            <div className=" grow items-center justify-center pt-32 px-10">
                <img src={ErrorIcon} alt="error" className=" m-auto" />
                <p className=" text-center my-4 text-xl font-bold">
                    {' '}
                    باگ خوردیم :(
                </p>
                <p className=" text-center font-bold">
                    گاهی بعضی چیزا درست کار نمیکنن
                </p>
                <button
                    onClick={() => navigate('/')}
                    className=" bg-green-1 mx-auto flex justify-center text-white py-2.5 rounded-lg w-full my-10"
                >
                    بازگشت به همیان
                </button>
            </div>
        </div>
    )
}
